import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { FinancesPage } from "@/features/domain/components/finances-page";
import { useI18n } from "@/providers/i18n-provider";

function FinancesRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Finances`)}
      description={t(msg`Sign in to manage your church finances.`)}
    >
      <PageContainer maxWidth="3xl">
        <FinancesPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const financesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/finances",
  component: FinancesRoutePage,
});
